const DATA_SUBJECT_MAIN_DRIVER_STEP_1 = 'data-subject-ticket-main-driver-step-1'
const DATA_SUBJECT_MAIN_DRIVER_STEP_2 = 'data-subject-ticket-main-driver-step-2'
const DATA_SUBJECT_MAIN_DRIVER_STEP_3 = 'data-subject-ticket-main-driver-step-3'
const DATA_SUBJECT_MAIN_DRIVER_STEP_4 = 'data-subject-ticket-main-driver-step-4'

const DATA_SUBJECT_MAIN_STEPS_OBJECT = [
  {
    element: '#' + DATA_SUBJECT_MAIN_DRIVER_STEP_1,
    popover: {
      description:
        'Na tela de solicitação de titulares ficam registradas todas as solicitações enviadas pelos titulares de dados para a sua empresa. ' +
        'Essas solicitações podem incluir: Pedido de acesso às informações que a empresa possui sobre ele; ' +
        'Correção ou atualização de dados pessoais; Exclusão de informações; Outras requisições relacionadas aos direitos do titular.',
    },
  },
  {
    element: '#' + DATA_SUBJECT_MAIN_DRIVER_STEP_2,
    popover: {
      description:
        'Defina quais usuários terão permissão para visualizar essa tela e quais poderão responder às solicitações. ' +
        '<strong>Importante:</strong> o acesso concedido é restrito apenas às solicitações da categoria correspondente.',
    },
  },
  {
    element: '#' + DATA_SUBJECT_MAIN_DRIVER_STEP_3,
    popover: {
      description:
        'Monitore o status das solicitações e verifique quantas estão em andamento, concluídas ou pendentes. ' +
        '<strong>Atenção:</strong> não permita que prazos sejam ultrapassados.',
    },
  },
  {
    element: '#' + DATA_SUBJECT_MAIN_DRIVER_STEP_4,
    popover: {
      description:
        'Resumo das solicitações. Ao clicar em Ações, você será direcionado para a tela de visualização detalhada da solicitação, ' +
        'onde poderá consultar todas as informações e tomar as medidas necessárias.',
    },
  },
]

const DATA_SUBJECT_CONFIG_DRIVER_STEP_1 =
  'data-subject-ticket-config-driver-step-1'
const DATA_SUBJECT_CONFIG_DRIVER_STEP_2 =
  'data-subject-ticket-config-driver-step-2'
const DATA_SUBJECT_CONFIG_DRIVER_STEP_3 =
  'data-subject-ticket-config-driver-step-3'
const DATA_SUBJECT_CONFIG_DRIVER_STEP_4 =
  'data-subject-ticket-config-driver-step-4'

const DATA_SUBJECT_CONFIG_STEPS_OBJECT = [
  {
    element: '#' + DATA_SUBJECT_CONFIG_DRIVER_STEP_1,
    popover: {
      description:
        'Selecione quais usuários poderão visualizar as solicitações e quais terão permissão para responder.',
    },
  },
  {
    element: '#' + DATA_SUBJECT_CONFIG_DRIVER_STEP_2,
    popover: {
      description:
        'Determine o tipo de solicitação e vincule o responsável por ela. ' +
        'Cada pessoa terá acesso apenas à categoria da qual foi vinculada.',
    },
  },
  {
    element: '#' + DATA_SUBJECT_CONFIG_DRIVER_STEP_3,
    popover: {
      description:
        'Adicione novas opções de resposta para tornar a comunicação mais clara e completa.',
    },
  },
  {
    element: '#' + DATA_SUBJECT_CONFIG_DRIVER_STEP_4,
    popover: {
      description:
        'Certifique-se de salvar as configurações para que passem a ter validade e efeito imediato.',
    },
  },
]

const DATA_SUBJECT_SHOW_DRIVER_STEP_1 = 'data-subject-ticket-show-driver-step-1'
const DATA_SUBJECT_SHOW_DRIVER_STEP_2 = 'data-subject-ticket-show-driver-step-2'
const DATA_SUBJECT_SHOW_DRIVER_STEP_3 = 'data-subject-ticket-show-driver-step-3'
const DATA_SUBJECT_SHOW_DRIVER_STEP_4 = 'data-subject-ticket-show-driver-step-4'
const DATA_SUBJECT_SHOW_DRIVER_STEP_5 = 'data-subject-ticket-show-driver-step-5'

const DATA_SUBJECT_SHOW_STEPS_OBJECT = [
  {
    element: '#' + DATA_SUBJECT_SHOW_DRIVER_STEP_1,
    popover: {
      description:
        'Aqui você pode acompanhar todo o histórico do chamado, incluindo as interações entre o solicitante e o Encarregado de Proteção de Dados(DPO). ' +
        'É possível interagir diretamente com o Encarregado de Proteção de Dados(DPO), porém lembre-se: <strong>suas mensagens não ficam visíveis para o solicitante.</strong>',
    },
  },
  {
    element: '#' + DATA_SUBJECT_SHOW_DRIVER_STEP_2,
    popover: {
      description:
        'Todas as interações relacionadas ao chamado estarão registradas nesta seção para consulta.',
    },
  },
  {
    element: '#' + DATA_SUBJECT_SHOW_DRIVER_STEP_3,
    popover: {
      description:
        'O chamado pode ser atribuído a um ou mais responsáveis. Dessa forma, eles poderão responder à solicitação. ' +
        'Caso o usuário não tenha permissão para visualizar a tela completa, ele terá acesso apenas a esse chamado específico.',
    },
  },
  {
    element: '#' + DATA_SUBJECT_SHOW_DRIVER_STEP_4,
    popover: {
      description:
        'Nesta seção ficam as informações principais do solicitante, facilitando a identificação e o tratamento adequado da solicitação.',
    },
  },
  {
    element: '#' + DATA_SUBJECT_SHOW_DRIVER_STEP_5,
    popover: {
      description:
        'Interaja com a solicitação informando se existem dados do titular e quais são esses dados. ' +
        'Caso necessário, <strong>anexe documentos</strong> em “Anexar”. ' +
        'Para enviar uma resposta ao solicitante, lembre-se de alterar o status para um válido antes de concluir o envio da mensagem.',
    },
  },
]

export default {
  DATA_SUBJECT_MAIN_DRIVER_STEP_1,
  DATA_SUBJECT_MAIN_DRIVER_STEP_2,
  DATA_SUBJECT_MAIN_DRIVER_STEP_3,
  DATA_SUBJECT_MAIN_DRIVER_STEP_4,
  DATA_SUBJECT_MAIN_STEPS_OBJECT,
  DATA_SUBJECT_CONFIG_DRIVER_STEP_1,
  DATA_SUBJECT_CONFIG_DRIVER_STEP_2,
  DATA_SUBJECT_CONFIG_DRIVER_STEP_3,
  DATA_SUBJECT_CONFIG_DRIVER_STEP_4,
  DATA_SUBJECT_CONFIG_STEPS_OBJECT,
  DATA_SUBJECT_SHOW_DRIVER_STEP_1,
  DATA_SUBJECT_SHOW_DRIVER_STEP_2,
  DATA_SUBJECT_SHOW_DRIVER_STEP_3,
  DATA_SUBJECT_SHOW_DRIVER_STEP_4,
  DATA_SUBJECT_SHOW_DRIVER_STEP_5,
  DATA_SUBJECT_SHOW_STEPS_OBJECT,
}
